import { RagAnalyticsEventName } from '@lokalise/types'
import { useEffect } from 'react'
import { useRagAnalytics } from '../../../providers/analytics'
import { getPlanIdFromSession, getUserIdFromSession } from '../../../utils/api'

export const useDispatchBannerAnalyticsEvent = (variant: string) => {
  const track = useRagAnalytics()

  useEffect(() => {
    track(RagAnalyticsEventName.AI_PROFILE_PAGE_BANNER_SHOWN, {
      variant,
      plan_id: getPlanIdFromSession(),
      user_id: getUserIdFromSession(),
    })
  }, [track, variant])
}
